<div class="steps">
  @for (step of steps; track step.label; let i = $index) {
    @if (i > 0) {
      @if (step.active) {
        <svg class="step-line" viewBox="0 0 82 6" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 3C2 1.34315 3.34315 0 5 0H11C12.6569 0 14 1.34315 14 3C14 4.65685 12.6569 6 11 6H5C3.34315 6 2 4.65685 2 3Z"
            [attr.fill]="colourHex" />
          <path
            d="M68 3C68 1.34315 69.3431 0 71 0H77C78.6569 0 80 1.34315 80 3C80 4.65685 78.6569 6 77 6H71C69.3431 6 68 4.65685 68 3Z"
            [attr.fill]="colourHex" />
          <path
            d="M20 3C20 1.34315 21.3431 0 23 0H35C36.6569 0 38 1.34315 38 3C38 4.65685 36.6569 6 35 6H23C21.3431 6 20 4.65685 20 3Z"
            [attr.fill]="colourHex" />
          <path
            d="M44 3C44 1.34315 45.3431 0 47 0H59C60.6569 0 62 1.34315 62 3C62 4.65685 60.6569 6 59 6H47C45.3431 6 44 4.65685 44 3Z"
            [attr.fill]="colourHex" />
        </svg>
      } @else if (steps[i - 1].active) {
        <svg class="step-line" viewBox="0 0 82 6" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 3C2 1.34315 3.34315 0 5 0H11C12.6569 0 14 1.34315 14 3C14 4.65685 12.6569 6 11 6H5C3.34315 6 2 4.65685 2 3Z"
            [attr.fill]="colourHex" />
          <path
            d="M68 3C68 1.34315 69.3431 0 71 0H77C78.6569 0 80 1.34315 80 3C80 4.65685 78.6569 6 77 6H71C69.3431 6 68 4.65685 68 3Z"
            fill="black"
            fill-opacity="0.25" />
          <path
            d="M20 3C20 1.34315 21.3431 0 23 0H35C36.6569 0 38 1.34315 38 3C38 4.65685 36.6569 6 35 6H23C21.3431 6 20 4.65685 20 3Z"
            [attr.fill]="colourHex" />
          <path
            d="M44 3C44 1.34315 45.3431 0 47 0H59C60.6569 0 62 1.34315 62 3C62 4.65685 60.6569 6 59 6H47C45.3431 6 44 4.65685 44 3Z"
            fill="black"
            fill-opacity="0.25" />
        </svg>
      } @else {
        <svg class="step-line" viewBox="0 0 82 6" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 3C2 1.34315 3.34315 0 5 0H11C12.6569 0 14 1.34315 14 3C14 4.65685 12.6569 6 11 6H5C3.34315 6 2 4.65685 2 3Z"
            fill="black"
            fill-opacity="0.25" />
          <path
            d="M68 3C68 1.34315 69.3431 0 71 0H77C78.6569 0 80 1.34315 80 3C80 4.65685 78.6569 6 77 6H71C69.3431 6 68 4.65685 68 3Z"
            fill="black"
            fill-opacity="0.25" />
          <path
            d="M20 3C20 1.34315 21.3431 0 23 0H35C36.6569 0 38 1.34315 38 3C38 4.65685 36.6569 6 35 6H23C21.3431 6 20 4.65685 20 3Z"
            fill="black"
            fill-opacity="0.25" />
          <path
            d="M44 3C44 1.34315 45.3431 0 47 0H59C60.6569 0 62 1.34315 62 3C62 4.65685 60.6569 6 59 6H47C45.3431 6 44 4.65685 44 3Z"
            fill="black"
            fill-opacity="0.25" />
        </svg>
      }
    }
    @if (step.active) {
      <svg class="step" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4 8C6.20898 8 8 6.20911 8 4C8 1.79089 6.20898 0 4 0C1.79102 0 0 1.79089 0 4C0 6.20911 1.79102 8 4 8ZM6.0752 3.20264C6.26562 3.00293 6.25879 2.6864 6.05859 2.49573C5.85938 2.30505 5.54297 2.31238 5.35254 2.51221L3.50879 4.44348L2.62305 3.63171C2.41992 3.44507 2.10352 3.45886 1.91699 3.66248C1.73047 3.86597 1.74414 4.18225 1.94727 4.3689L3.55566 5.84277L6.0752 3.20264Z"
          [attr.fill]="colourHex" />
      </svg>
    } @else {
      <svg class="step" viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg">
        <g>
          <circle cx="4.00001" cy="4.00001" r="4.00001" fill="black" fill-opacity="0.25" />
        </g>
      </svg>
    }
  }
</div>
